import get from "lodash/get";
import orderBy from "lodash/orderBy";
import moment from "moment";

import Translate from "utils/translate";
import { fullName } from "utils/user";

const { t } = new Translate();

export const assetLeadSort = (assetLeads, key, dir) => {
  const sortKeys = {
    category:
      () =>
      ({ category }) =>
        category && t(`assetCategories.${category}`),
    closeDate:
      () =>
      ({ closeDate }) =>
        closeDate && moment(closeDate),
    contacts: () => (assetLead) => get(assetLead, "contacts[0].company"),
    feePotential:
      () =>
      ({ feePotential }) =>
        get(feePotential, "value"),
    lastItem:
      () =>
      ({ lastItem }) =>
        get(lastItem, "createdAt"),
    name:
      () =>
      ({ name }) =>
        name,
    pointPerson:
      () =>
      ({ pointPerson }) =>
        fullName(pointPerson),
    portfolio:
      () =>
      ({ portfolio }) =>
        get(portfolio, "name"),
    probability:
      () =>
      ({ probability }) =>
        probability && parseInt(probability.replace("%", ""), 10),
    size:
      () =>
      ({ size }) =>
        get(size, "from"),
  };

  const sortKey = (dir && sortKeys[key] ? sortKeys[key] : sortKeys.lastItem)();

  return orderBy(assetLeads, sortKey, dir ? dir.toLowerCase() : "desc");
};
